import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'

interface ModalProps {
  title: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl';
  onClose: () => void;
  children: React.ReactNode;
}

export default function Modal({
  title,
  maxWidth = 'sm',
  onClose,
  children,
}: ModalProps) {
  return (
    <Dialog
      open
      maxWidth={maxWidth}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogTitle>{title}</DialogTitle>
      {children}
    </Dialog>
  )
}
